import { FaRegBell, FaExpand, FaBars } from "react-icons/fa";
import { useDispatch, useSelector } from "react-redux";
import { handleDarkMode, handleHambergerState } from "../../HandleSlice/HandleSlice";
import { FaCompress } from "react-icons/fa";
import { useEffect, useRef, useState } from "react";
import { BsWifi } from "react-icons/bs";
import { BsWifiOff } from "react-icons/bs";
import { handleconnectionFailed } from "../../HandleSlice/HandleSlice";
import axios from "axios";
import Switcher from "../../components/Switcher/Switcher";
import LoadingSpinner from "../../components/LoadingSpinner/LoadingSpinner";
import { history } from "../../helpers/history";

const Header = (props) => {
    const [screenState, setScreenState] = useState(true);
    const [profileState, setProfileState] = useState(false);
    const [isOnline, setIsOnline] = useState(navigator.onLine);
    const [localTheme] = useState(localStorage.getItem("theme"))
    const [autoDarkModeState, setAutoDarkModeState] = useState(false)
    const [isLoading, setIsLoading] = useState(false);
    const btnRef = useRef();


    const data = useSelector((state) => state.hamberger);

    const dispatch = useDispatch();


    useEffect(() => {
        if (localStorage.getItem("autoDarkMode") === "true") {
            autoDarkModeHandler()
        }
    }, [autoDarkModeState])


    function autoDarkModeHandler(params) {
        //check user's system theme
        if (window.matchMedia && window.matchMedia('(prefers-color-scheme: dark)').matches) {
            localStorage.setItem("theme", "dark")
            window.document.documentElement.classList.remove("light");
            window.document.documentElement.classList.add("dark");
        } else {
            localStorage.setItem("theme", "light")
            window.document.documentElement.classList.remove("dark");
            window.document.documentElement.classList.add("light");
        }
        dispatch(handleDarkMode(!data.darkModeState))
    }

    useEffect(() => {
        // Update network status
        const handleStatusChange = () => {
            setIsOnline(navigator.onLine);
            // window.location.reload(true);
            // dispatch(handleconnectionFailed(!isOnline));
        };
        // Listen to the online status
        window.addEventListener("online", handleStatusChange);

        // Listen to the offline status
        window.addEventListener("offline", handleStatusChange);
        // Specify how to clean up after this effect for performance improvment

        return () => {
            window.removeEventListener("online", handleStatusChange);
            window.removeEventListener("offline", handleStatusChange);
        };
    }, [isOnline, dispatch]);

    const hambergerHandler = () => {
        if (data.hambergerState === true) {
            dispatch(handleHambergerState(false));
        } else if (data.hambergerState === false) {
            dispatch(handleHambergerState(true));
        }
    };

    useEffect(() => {
        const closeDropdown = (e) => {
            if (btnRef.current && !btnRef.current.contains(e.target)) {
                dispatch(handleHambergerState(true));
            }
        };
        document.body.addEventListener("click", closeDropdown);
        return () => document.body.removeEventListener("click", closeDropdown);
    }, [dispatch]);

    const fullScreenHandler = () => {
        if (document.body.requestFullscreen) {
            document.body.requestFullscreen();
        } else if (document.body.mozRequestFullScreen) {
            document.body.mozRequestFullScreen(); // Firefox
        } else if (document.body.webkitRequestFullscreen) {
            document.body.webkitRequestFullscreen(); // Chrome and Safari
        }
        setScreenState(false);
    };

    const minimizeScreenHandler = () => {
        if (document.exitFullscreen) {
            document.exitFullscreen();
        } else if (document.msExitFullscreen) {
            document.msExitFullscreen();
        } else if (document.mozCancelFullScreen) {
            document.mozCancelFullScreen();
        } else if (document.webkitExitFullscreen) {
            document.webkitExitFullscreen();
        }
        setScreenState(true);
    };

    const profileModalHandler = (e) => {
        e.stopPropagation();
        setProfileState(!profileState);
    };

    useEffect(() => {
        const body = document.body;
        body.addEventListener("click", () => {
            setProfileState(false);
        });
    }, []);


    // TODO
    const profileAndExitHandler = (event) => {
        if (event.currentTarget.getAttribute("id_value") === "logout") {
            setIsLoading(true)
            axios.post(event.currentTarget.getAttribute("logoutRout"), {}).then((res) => {
                localStorage.removeItem("Authorization");
                localStorage.removeItem("home_admin_data");
                localStorage.removeItem("projectURL");
                setIsLoading(false)
                history.navigate("/login")
            });
        }
    };

    return (
        <>
            {isLoading && <LoadingSpinner />}
            <header className="fixed 900:right-[270px] right-[12px] left-0 z-index dark:bg-[#152A38] bg-[#EAEDF7]">
                <div className={
                    "flex justify-between items-center pr-[20px] pl-[20px] py-[10px] ml-[12px] mt-[12px] bg-header_background dark:bg-[#D1D4C9] z-index 900:justify-between transition-all h-[60px] rounded-lg"
                }>
                    <div
                        className={`${!data.hambergerState ? "rotate-90" : "rotate-0"
                        } cursor-pointer text-[22px] text-[#3a3a3a] 900:hidden transition-all`}
                        ref={btnRef}
                        onClick={hambergerHandler}
                    >
                        <FaBars />
                    </div>
                    <div className="flex">
                        {props.headerData && props.headerData.logo &&
                            <img src={props.headerData.logo} className="max-h-[60px] px-[10px]" />}
                    </div>
                    <div className="flex justify-center items-center gap-2 relative">
                        <Switcher localTheme={localTheme} setAutoDarkModeState={setAutoDarkModeState}
                                  autoDarkModeState={autoDarkModeState} />
                        {isOnline ? (
                            <div
                                title="اتصال شما برقرار است"
                                className="flex items-center gap-2 mx-1"
                                dir="ltr">
                                <BsWifi className="text-green-600 text-[20px] 560:text-[26px]" />
                            </div>
                        ) : (
                            <div
                                title="اتصال اینترنت خود را بررسی کنید"
                                className="flex justify-center items-center gap-2 ml-6"
                                dir="ltr"
                            >
                                <BsWifiOff className="text-red-600 text-[20px] 560:text-[26px]" />
                            </div>
                        )}

                        {screenState ? (
                            <div
                                className="hover:bg-[#aaaaaa2d] rounded-full p-2 cursor-pointer text-[18px] 560:text-[22px] text-[#272727aa]"
                                onClick={fullScreenHandler}
                            >
                                <FaExpand />
                            </div>
                        ) : (
                            <div
                                className="hover:bg-[#aaaaaa2d] rounded-full p-2 cursor-pointer text-[18px] 560:text-[22px] text-[#272727aa]"
                                onClick={minimizeScreenHandler}
                            >
                                <FaCompress />
                            </div>
                        )}

                        <div className="hover:bg-[#aaaaaa2d] hidden 365:inline-block rounded-full p-2 cursor-pointer text-[18px] 560:text-[22px] text-[#272727aa]">
                            <FaRegBell />
                        </div>
                        <div className="w-[38px] cursor-pointer" onClick={profileModalHandler}>
                            <img src="https://darouvadarman.com/images/avatar.png" alt="" />
                        </div>
                        {profileState && (
                            <div
                                className="absolute top-[62px] left-[0px] bg-[#e2e2e2] w-[200px] transition-all duration-1000 rounded-lg overflow-hidden">
                                {props.headerData &&
                                    props.headerData.options.map((item, index) => (
                                        <div
                                            key={index}
                                            className="cursor-pointer hover:bg-[#bfbfbf] text-[#6a6a6a] hover:text-[#fff] py-4 px-2 flex items-center gap-2"
                                            id_value={item.key}
                                            onClick={profileAndExitHandler}
                                            logoutRout={item.route}
                                        >
                                            {item.key === "profile" ? (
                                                <>
                                                <span>
                                                    <i className="fa fa-user" aria-hidden="true"></i>
                                                </span>
                                                    <span>{item.label}</span>
                                                </>
                                            ) : item.key === "logout" ? (
                                                <>
                                                <span>
                                                    <i className="fa fa-sign-out" aria-hidden="true"></i>
                                                </span>
                                                    <span>{item.label}</span>
                                                </>
                                            ) : (
                                                ""
                                            )}
                                        </div>
                                    ))}
                            </div>
                        )}
                    </div>
                </div>

            </header>
        </>
    );
};
export default Header;
